<mat-card class="question-card">
  <mat-card-content>
    <mat-label class="mat-title question-text">{{title}}</mat-label>
    <div *ngIf="text">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="right-aligned-header">
          <mat-panel-title></mat-panel-title>
          <mat-panel-description>
            {{toggleText}}
          </mat-panel-description>         
        </mat-expansion-panel-header>       
        <p>{{text}}</p>       
      </mat-expansion-panel>
    </div>
    <div class="clearfix"></div>
    <div *ngIf="ctrl">
      <mat-error *ngIf="invalid">
        <div *ngIf="ctrl.errors.required" [innerHTML]="requiredErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && ctrl.errors.minAnswers" [innerHTML]="minAnswersErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && ctrl.errors.maxAnswers" [innerHTML]="maxAnswersErrorMessage"></div>
      </mat-error>
    </div>
    <input *ngIf="categories.length>5" type="text" class="form-control" placeholder="Search Here" [(ngModel)]="searchText">
    <div [formGroup]="form">
      <div [formGroup]="ctrl">
        <div *ngFor="let category of categories| searchOptionFilter:searchText:['name']; let i = index" class="form-control">
          <mat-checkbox color="primary" [formControl]="getCtrl(category.code)" [value]="category.code" (click)="clickHandler(category.code, $event)">
            <span *ngIf="!category.isOther" class="category-text">{{category.rightText}}</span>
            <mat-form-field *ngIf="category.isOther">
              <input matInput placeholder="{{category.rightText}}" [formControl]="otherCtrls[category.code]" />
            </mat-form-field>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
